import React from 'react';

export const CheckIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 46.63 44.305">
      <path fill="#fff"
            d="M32.516,23c.287.028.574.056.866.074a20.933,20.933,0,0,1,6.045,1.356,21.55,21.55,0,0,1,6.82,4.217c.009.009.018.023.046.06-.511.576-1.021,1.156-1.541,1.742a18.988,18.988,0,0,0-16.138-4.784,18.7,18.7,0,0,0-11.793,6.9,19.96,19.96,0,0,0-.57,24.467,19.136,19.136,0,0,0,23.9,5.95A19.926,19.926,0,0,0,50.372,39.543l2.234-.678c.073.265.15.516.214.771a22.414,22.414,0,0,1,.634,6.9,22,22,0,0,1-4.942,12.707,21.379,21.379,0,0,1-11.046,7.282,21.411,21.411,0,0,1-15.14-1.412,21.59,21.59,0,0,1-7.134-5.624,22.122,22.122,0,0,1-4.677-9.577,21.656,21.656,0,0,1-.483-3.79c0-.093-.023-.186-.032-.274V44.467c.009-.079.023-.153.032-.232.091-.9.146-1.811.278-2.708a20.855,20.855,0,0,1,1.436-5.048,22.032,22.032,0,0,1,4.563-6.9,21.571,21.571,0,0,1,8.206-5.309A20.587,20.587,0,0,1,30.1,23.079c.324-.023.647-.051.971-.079Z"
            transform="translate(-10 -23)"/>
      <path fill="#fff"
            d="M140.243,165.381q5.118,5.705,10.27,11.457L173.77,150.9c1.108,1.235,2.187,2.443,3.267,3.646q-13.222,14.738-26.5,29.538Q143.763,176.543,137,169,138.591,167.22,140.243,165.381Z"
            transform="translate(-130.406 -148.075)"/>
    </svg>
  );
};

CheckIcon.propTypes = {}

CheckIcon.defaultProps = {}

export default React.memo(CheckIcon);